import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import {withEuroOrDash, withPercentOrDash} from "../../../../../../utils/utils";
import ExpandCollapseButton from "./ExpandCollapseButton";
import {NameCol} from "../PortfolioTradeV2/table-data";
import {PortfolioNameColumn} from "../../../TradeStep/components/PortfolioTrade/table-data";
import {TRANSACTION_TYPE_VALUES} from "../../../../constants";
import {PrimaryButton} from "../../../../../../components/Buttons";

const DEFAULT_ADD_BTN_NAMES = {
  [TRANSACTION_TYPE_VALUES.SELL]: 'Produkte auswählen',
  [TRANSACTION_TYPE_VALUES.SWITCH]: 'Produkte zum Tausch auswählen',
}

export const DEFAULT_ADD_BTN = 'Investment hinzufügen'

/**
 * Expand/collapse column for MP/PI tables.
 * Shows toggle on transaction items, hidden on asset rows.
 */
export const MPExpandCol = {
  header: [() => ''],
  body: [({ item, options }) => {
    if (item.mpComponent) return null;

    return (
      <ExpandCollapseButton
        expanded={options.checkExpanded(item)}
        onClick={() => options.expandSummaryLineChange(item)}
      />
    );
  }],
  align: 'center',
  cellClassName: 'expand-cell',
  footerCellClassName: 'bg-white',
};

/**
 * Weight column for MP/PI asset rows.
 * Shows component weight percentage, empty for transaction items.
 */
export const MPWeightCol = {
  header: [() => 'Gewichtung'],
  body: [({ item }) => withPercentOrDash(item.mpComponent ? item.weight : 100, false)],
  footer: [() => 'Gesamt'],
  align: 'right',
};

export const NameColCommon = {
  footer: [({ items, options }) => {
    // no btn if there's MP selected already
    if(options.isModelportfolio && options.itemsLength > 0 && [TRANSACTION_TYPE_VALUES.BUY, TRANSACTION_TYPE_VALUES.SELL].includes(options.action)){
      return null;
    }

    return (
      <Grid container alignItems={'center'}>
        <Grid item xs>
          <PrimaryButton
            text={options.addButtonText || DEFAULT_ADD_BTN_NAMES[options.action] || DEFAULT_ADD_BTN}
            icon={<i className={'fal fa-plus'} />}
            onButtonClick={() => options.handleAddClick(options.action)}
          />
        </Grid>
        {_.some(items, (i) => _.get(i, 'errors.disabledByFilter')) && (
          <Grid item xs={'auto'} style={{color: 'red'}}>
            <b>Die gewählten Instrumente können nicht verwendet werden</b>
          </Grid>
        )}
      </Grid>
    );
  }],
  cellClassName: 'name-cell',
  footerCellClassName: 'bg-white',
}

export const PortfolioNameCol = {
  ...NameColCommon,
  header: [() => <>Produktname<br/>MP Nummer / ISIN / WKN</>],
  body: [({ item, options }) => {
    if (item.mpComponent) {
      return NameCol.body[0]({ item, options });
    }
    return PortfolioNameColumn.body[0]({ item, options });
  }],
  colSpan: {footer: 3}
}

export const PriceColumn = {
  header: [() => 'Kurs'],
  body: [({item, options}) => {
    return (
      withEuroOrDash(item.data && item.data.calculated && item.data.calculated.last_price_value)
    )
  }],
  footer: [() => null],
  align: 'right',
  footerCellClassName: 'bg-white',
}
